import React from 'react';

const Welcome = () => {
    return (
        <div>
            EPA is setting the level of the primary (health-based) annual PM2.5 standard at 9.0 micrograms per cubic meter (µg/m3) to reflect new science on harms caused by particle pollution.
        </div>
    );
};

export default Welcome;